// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-66ee43f6] .el-link--inner{display:flex;align-items:center;justify-content:space-between;padding-bottom:10px;border-bottom:1px dashed #ddd}", ""]);
// Exports
module.exports = exports;
